import React from "react";
import { RCCIcon, RCCLoader, RCCPopover } from "react-common-components";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { IHeaderDashboard } from "./interface";
import { ContentHeader } from "./styles";

const HeaderDashboard: React.FC<IHeaderDashboard> = ({
	children,
	title,
	description,
	hexColor,
	isLoading
}) => {
	const { translate } = useTranslation();
    
	return(
		<ContentHeader>
			<Title size="md" color="purple" hexColor={hexColor} bold>
				{isLoading && <RCCLoader color="purple" styleInline="width: 16px !important; height: 16px !important; margin-right: 8px;" />}
				{title}
				{description && description.trim().length > 0 && (
					<RCCPopover
						color="grey"
						header={{
							title: translate("Descrição")
						}}
						body={{
							text: description
						}}
						position="top"
					>
						<div className="infoCircleDescription-card">
							<RCCIcon name="exclamationCircle" color="var(--grey)" size={16} />
						</div>
					</RCCPopover>
				)}
			</Title>
			<div style={{ display: "flex" }}>
				{children}
			</div>
		</ContentHeader>
	);};

export default HeaderDashboard;
